// UF-03: the Verify card's slot on a completed run's Overview. The card needs
// the QC read; when that read fails the slot says so with a Retry instead of
// the card silently vanishing, and while it loads it says it is checking.
// A failed read is never shown as "nothing to verify".
import type { ReactNode } from 'react'
import WidgetRetry from '@/components/WidgetRetry'

type QcRead<T> = {
  data: T | undefined
  isError: boolean
  isFetching: boolean
  refetch: () => unknown
}

export function VerifyQcGate<T>({
  status, qcQ, children,
}: {
  status: string
  qcQ: QcRead<T>
  children: (qc: T) => ReactNode
}) {
  if (status !== 'COMPLETE') return null
  if (qcQ.data) return <>{children(qcQ.data)}</>
  if (qcQ.isError) {
    return (
      <div className="card space-y-2" data-testid="verify-qc-failed">
        <p className="text-sm text-fg-secondary">Verify &amp; Publish needs the QC check.</p>
        <WidgetRetry noun="QC" busy={qcQ.isFetching} onRetry={() => { void qcQ.refetch() }} />
      </div>
    )
  }
  return <p className="text-caption text-fg-muted" data-testid="verify-qc-loading">Checking QC…</p>
}
